import React from 'react';
import {connect} from 'react-redux';
import {Modal, Row, Col, Form, Radio, Button, Spin, Card} from 'antd';
import {Input} from 'antd';
import {actions} from './reducers';
import {formItemLayout} from './utils';
import ReactJson from 'react-json-view'
import {createPatch} from 'diff'
import {Diff2Html} from 'diff2html'
import 'diff2html/dist/diff2html.css'
import './styles.scss'

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

class Edit extends React.Component {

    state = {
        isVisible: false,
    };


    componentDidMount() {
    }

    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
    };

    handleCompareCancel = () => {
        this.setState({
            isVisible: false,
        });
    };

    handleCompareOnClick = () => {
        this.setState({
            isVisible: true,
        });
    }

    // 生成比较代码页面
    createCodeDiffHtml = (oldString, newString) => {

        if (!oldString) {
            return;
        }
        if (!newString) {
            return;
        }
        // 输出格式
        const outputFormat = 'side-by-side';
        // 不同地方上下间隔多少行不隐藏
        const context = 5;
        // 处理参数
        oldString = JSON.stringify(JSON.parse(oldString), null, 4);
        newString = JSON.stringify(JSON.parse(newString), null, 4);
        let diff = createPatch(...['', oldString, newString, '入参', '出参', {context: context}])
        let outStr = Diff2Html.getJsonFromDiff(diff, {
            inputFormat: 'diff',
            outputFormat: outputFormat,
            showFiles: false,
            matching: 'lines'
        })
        let html = Diff2Html.getPrettyHtml(outStr, {
            inputFormat: 'json',
            //outputFormat: outputFormat,
            showFiles: false,
            matching: 'lines'
        })
        return html;
    }

    render() {
        const {isModalShow, filterData = {}} = this.props;

        const {getFieldDecorator} = this.props.form;

        const form = (
            <Form>
                <Row gutter={16}>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="订单id">
                            {getFieldDecorator('eId', {
                                initialValue: filterData.eId,
                            })(
                                <Input style={{width: '100%'}}/>,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="订单名称">
                            {getFieldDecorator('eName', {
                                initialValue: filterData.eName,
                            })(
                                <Input style={{width: '100%'}}/>,
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="任务id">
                            {getFieldDecorator('taskId', {
                                initialValue: filterData.taskId,
                            })(
                                <Input style={{width: '100%'}}/>,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="uuid">
                            {getFieldDecorator('uuid', {
                                initialValue: filterData.uuid,
                            })(
                                <Input style={{width: '100%'}}/>,
                            )}
                        </FormItem>
                    </Col>
                </Row>

                <Row>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="开始时间">
                            {getFieldDecorator('startTime', {
                                initialValue: filterData.startTime,
                            })(
                                <Input style={{width: '100%'}}/>,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="服务器ip">
                            {getFieldDecorator('ip', {
                                initialValue: filterData.ip,
                            })(
                                <Input style={{width: '100%'}}/>,
                            )}
                        </FormItem>
                    </Col>
                </Row>

                <Row>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="结束时间">
                            {getFieldDecorator('endTime', {
                                initialValue: filterData.endTime,
                            })(
                                <Input style={{width: '100%'}}/>,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="耗时">
                            {getFieldDecorator('time', {
                                initialValue: filterData.time,
                            })(
                                <Input style={{width: '100%'}} suffix={'ms'}/>,
                            )}
                        </FormItem>
                    </Col>
                </Row>

                <Row>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="分派时间">
                            {getFieldDecorator('assignTime', {
                                initialValue: filterData.assignTime,
                            })(
                                <Input style={{width: '100%'}}/>,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={12}>
                        <FormItem {...formItemLayout} label="消息">
                            {getFieldDecorator('msg', {
                                initialValue: filterData.msg,
                            })(
                                <Input style={{width: '100%'}}/>,
                            )}
                        </FormItem>
                    </Col>
                </Row>

                <Row>
                    {filterData.inContext && <Col span={19}>
                        <FormItem {...formItemLayout} label="入参" labelCol={{span: 2, offset: 2}}
                                  wrapperCol={{span: 19}}>
                            <div style={{overflowY: 'auto'}}>
                                <ReactJson src={JSON.parse(filterData.inContext)} collapsed={true} name={null}
                                           theme={"ocean"}
                                           displayDataTypes={false}/>
                            </div>

                        </FormItem>
                    </Col>}
                    {filterData.inContext && filterData.outContext && <Col span={2}>
                        <Button size="small" type="danger"
                                onClick={() => this.handleCompareOnClick()}>对比参数</Button>
                    </Col>}
                </Row>

                <Row>
                    {filterData.outContext && <Col span={19}>
                        <FormItem {...formItemLayout} label="出参" labelCol={{span: 2, offset: 2}}
                                  wrapperCol={{span: 19}}>
                            <div style={{overflowY: 'auto'}}>
                                <ReactJson src={JSON.parse(filterData.outContext)} collapsed={true} name={null}
                                           theme={"ocean"}
                                           displayDataTypes={false}/>
                            </div>
                        </FormItem>
                    </Col>}
                </Row>

                <Row>
                    {filterData.critialContent && <Col span={24}>
                        <FormItem {...formItemLayout} label="重要信息" labelCol={{span: 2, offset: 1}}
                                  wrapperCol={{span: 20}}>
                            {getFieldDecorator('critialContent', {
                                initialValue: filterData.critialContent,
                            })(
                                <Input.TextArea autosize={{minRows: 4, maxRows: 10}} style={{width: '100%'}}/>,
                            )}
                        </FormItem>
                    </Col>
                    }
                </Row>

                <Row>
                    {filterData.errorInfo && <Col span={24}>
                        <FormItem {...formItemLayout} label="异常信息" labelCol={{span: 2, offset: 1}}
                                  wrapperCol={{span: 20}}>
                            {getFieldDecorator('errorInfo', {
                                initialValue: filterData.errorInfo,
                            })(
                                <Input style={{width: '100%', color: 'red'}}/>,
                            )}
                        </FormItem>
                    </Col>
                    }
                </Row>

                <Row>
                    {filterData.errorDetailInfo && <Col span={24}>
                        <FormItem {...formItemLayout} label="异常详细信息" labelCol={{span: 2, offset: 1}}
                                  wrapperCol={{span: 20}}>
                            {getFieldDecorator('errorDetailInfo', {
                                initialValue: filterData.errorDetailInfo,
                            })(
                                <Input.TextArea placeholder="异常详细信息" autosize={{minRows: 4, maxRows: 20}}
                                                style={{width: '100%', color: 'red'}}/>,
                            )}
                        </FormItem>
                    </Col>
                    }
                </Row>

            </Form>
        );


        const model = (
            <div className="createCode"
                 dangerouslySetInnerHTML={{__html: this.createCodeDiffHtml(filterData.inContext, filterData.outContext)}}></div>
        );

        return (
            <span>
                <Modal
                    width={filterData.code == 200 ? 800 : 1200}
                    title={filterData.name}
                    visible={isModalShow}
                    onCancel={this.handleCancel}
                    maskClosable={true}
                    footer={null}
                >
                    {form}
                    <Modal
                        width={850}
                        title={"对比参数"}
                        visible={this.state.isVisible}
                        onCancel={this.handleCompareCancel}
                        maskClosable={true}
                        footer={null}
                    >
                        {model}
                    </Modal>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    isModalShow: state.logCollect.uiStatus.isUpdateShow,
    isLoading: state.logCollect.uiStatus.isLoading,
    filterData: state.logCollect.filterData,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({isUpdateShow: false})),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./pages/assist/logCollect/edit.js